<template>
  <div class="confirmorder_main">
    <div class="confirmmain main_top">
      <nav-bar
        :lefticon="returnwhiteicon"
        :lefticonheight="2.0"
        :lefticonwidth="2.0"
        titlecolor="#ffffff"
        :righticon="helpicon"
        :title="info.chinese_name"
        @goback="goback"
        righttext="帮助"
        :righticonshow="true"
        @rightclick="customer()"
      ></nav-bar>
    </div>
    <div style="background: #108b30;margin-bottom:1.0rem;">
    <div class="box_main">
      <div class="btndiv headline">{{ info.roomTypeName }}</div>
      <div class="btndiv box_item">
        <span class="box_date">{{info.starttime}}</span>
        <span class="box_time"><span>{{info.roomday}}晚</span></span>
        <span class="box_date">{{info.endtime}}</span>
        <span class="box_facility" @click="skip()"
          >房型详情
          <img :src="unfoldright" alt="" style="width:1rem;position: absolute;top:0.4rem;"/>
        </span>
      </div>
      <div class="btndiv tag">
        <span>{{info.labelBedName?info.labelBedName:'-'}}</span>
        <span>{{info.mealBreakFast}}</span>
        <span>{{info.hasWindow}}</span>
      </div>
      <div class="btndiv tags">{{info.cancelPolicy=='免费取消'?'北京时间'+can_cancel_time+'前可免费取消此订单，逾期无法取消':info.cancelPolicy}}</div>
      <!-- <div class="notice">
        <p class="title">订房必读</p>
        <ul>
          <li v-for="(item, index) in info.policy" :key="index">
            <label></label><span v-html="item.Text"></span>
          </li>
        </ul>
      </div> -->
    </div>
    </div>
    <div class="item_main">
      <p class="title">入住信息</p>
      <p class="items tips">姓名与证件一致，每间只需填写1位</p>
      <p class="items" @click="isroom = !isroom">
        <span class="tiptext text">房间数</span
        ><label class="tag">{{ form.room_num }}间</label
        ><span class="tiptext">每间最多住两人</span
        ><img
          :src="isroom ? unfoldtop : unfoldbottom"
          class="imgo"
        />
      </p>
      <div class="room">
        <p class="mark" v-if="isroom">预订更多房间，我们会为您重新计算价格</p>
        <div class="room_list" v-if="isroom">
          <p class="roomo">
            <span
              v-for="(item, index) in roomlist"
              :key="index"
              :class="item.split('间')[0] == form.room_num? 'room_item room_active':info.maxNum<item.split('间')[0]?'room_item room_none':'room_item'"
              @click="info.maxNum<item.split('间')[0]?'':changeroom(item)">{{ item }}</span
            >
          </p>
        </div>
      </div>
      <p class="items" v-if="form.room_num == 1">
        <span class="tiptext text">住客姓名</span
        ><input type="text" placeholder="请输入住客姓名" v-model="inputValue" />
      </p>
      <p class="items" v-for="(item, index) in rooms" :key="index">
        <span class="tiptext text">房间{{ index + 1 }}</span
        ><input
          type="text"
          placeholder="请输入住客姓名"
          v-model="rooms[index].Name"
        />
      </p>
      <p class="items">
        <span class="tiptext text">手机号码</span
        ><label class="tag" @click="areacode = true"
          >{{ areavalue }}<img :src="unfoldbottom" class="imgt_tel" /></label
        ><input style="width:17.0rem;"
          type="text"
          placeholder="请输入住客手机号码"
          v-model="form.mobile"
          maxlength="11"
        />
      </p>
    </div>
    <div class="item_main">
      <p class="title">优惠</p>
      <p class="onsale">离店后赠{{parseInt(info.credits*form.room_num)}}积分</p>
      <p class="title">
        入住偏好
        <img
          :src="ispreference ? unfoldtopl : unfoldbottoml"
          style="float: right;width:1.4rem;"
          @click="ispreference = !ispreference"
        />
      </p>
      <p class="label">酒店会尽量安排您的要求，但无法保证满足，请您谅解</p>
      <div class="askfor" v-if="ispreference">
        <p class="asktitle" @click="timepopup = true">
          预计到店时间<img :src="unfoldtopl" class="imgt" />
          <!-- <input
            type="text"
            placeholder="请选择预计到店时间"
            v-model="reachtime"
            ref="scanTextbox"
            @keyup.13="scannerByUsb"
            @focus="stopKeyborad"
          /> -->
          <span class="askspan" :style="reachtime!=''&&reachtime!=null?'color:#333333;font-weight:500;':''">{{reachtime==''||reachtime==null?'请选择预计到店时间':reachtime}}</span>
        </p>
        <div class="asktip" v-if="reachtime!=''&&reachtime!='不选择'&&istime!=-1">
          <span v-if="istime==0">{{arrivalTimeFrom.split('')[0]==0?'酒店为您办理入住的时间为'+arrivalTimeEnd+'前，请您做好出行安排喔～':'酒店为您办理入住的时间为'+arrivalTimeFrom+'-'+arrivalTimeEnd+'，请您做好出行安排喔～'}}</span>
          <span v-if="istime==1">您的到达时间早于最早入住时间{{arrivalTimeFrom}}，您可以先在前台办理手续，然后在规定时间入住。</span>
          <span v-if="istime==2">您的到达时间超过了酒店的最晚入住时间{{arrivalTimeEnd}}，酒店可能无法为您留房。建议提前与酒店确认。</span>
        </div>
        <p class="asktitle" v-if="isremark">其他的要求</p>
        <p v-if="isremark">
          <span
            :class="item.checked ? 'asklabel active' : 'asklabel'"
            v-for="(item, index) in asklist"
            :key="index"
            @click="changeask(item)"
            >{{ item.name }}</span
          >
        </p>
        <van-field v-if="isremark"
          v-model="askremark"
          rows="6"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="您可以在这里输入其他要求~"
          show-word-limit
        />
      </div>
    </div>
    <div class="item_main">
      <p class="title">发票/收据</p>
      <p class="remark">
        此订单发票/收据由酒店前台开具，请在入住完成后， 向酒店前台索取。
      </p>
      <p class="title" style="margin-top: 3.0rem">执行方</p>
      <p class="remark">携程</p>
    </div>
    <div class="orderbox" v-if="isshowbottom">
       <!-- v-if="isdeduction" -->
      <div style="margin-bottom:1.8rem;">
        <p class="deduction">
          使用红包抵扣
          <van-checkbox v-model="is_deduct_coin" @change="changededuct($event)" :disabled="money.nowCoin<100"></van-checkbox>
          <span :class="parseFloat(money.nowCoin)>=100 ? 'tip' : 'tip coloccc'">{{parseFloat(money.nowCoin)>=100 ? `红包可抵扣 ¥${info.deductCoin}`:'红包不足100，不可抵扣'}}</span>
          </p>
        <p class="remark">(红包剩余{{info.nowCoin}})</p>
      </div>
      <div class="order_box">
        <span class="tag">在线支付</span>
        <span class="price">¥<span class="sum">{{info.raisePrice?info.raisePrice.toString().split('.')[0]:''}}</span>.{{info.raisePrice && info.raisePrice.toString().split('.')[1]?info.raisePrice.toString().split('.')[1]:'00'}}</span>
        <span @click="show = true" style="position:relative;">
          <span class="btndetail">价格明细</span>
          <img :src="show ? unfoldbottom : unfoldtop" class="imgt_info" />
        </span>
        <van-button type="default" @click="save()" :loading="loading" loading-text="提交中" :loading-size="'1.6rem'">提交订单</van-button>
      </div>
    </div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      style="min-height:35%;max-height:60%;"
      class="orderpopup"
    >
        <p>
            <span class="title">价格明细</span>
            <img :src="close" class="close" @click="show = false" />
        </p>
        <div style="max-height:25.0rem;overflow:auto;">
            <div class="detail_box">
                <p class="detail_item">
                <span class="item_title">{{ info.roomTypeName }}</span>
                <span class="item_tip">{{form.room_num}}间客房 x {{info.roomday}}晚 {{info.mealBreakFast}}</span>
                </p>
                <div class="info_content" v-for="(item,index) in info.priceDetail" :key="index">
                <div :class="index===info.priceDetail.length-1 ? 'lastinfo' :'info_content'" >
                    <p>
                        <span class="items">{{item.time}}&nbsp;{{index===0? '无餐食' : info.meals || '无餐食'}}{{info.meals!=''&&index!=0?'/间':''}}</span>
                        <span class="items price_info">{{index===info.priceDetail.length-1 ? '' :   `1晚 ${'&nbsp;'}x ${'&nbsp;'}¥${item.dailyPrice}`}}</span>
                    </p>
                </div>
                </div>
                <p>
                <span class="items">房费</span>
                <span class="price">¥{{this.is_deduct_coin ? info.nowCoin>=info.raisePrice/2 ? info.raisePrice*2  : parseFloat(info.raisePrice)+parseFloat(info.deductCoin) :info.raisePrice}}</span>
                </p>
                <p v-if="is_deduct_coin==true" style="margin-top:1.0rem;">
                <span class="items">红包抵扣</span>
                <span class="price">-¥{{info.deductCoin}}</span>
                </p>
            </div>
        </div>
        <div class="order_box">
            <span class="tag">在线支付</span>
            <span class="price">¥<span class="sum">{{info.raisePrice?info.raisePrice.toString().split('.')[0]:''}}</span>.{{info.raisePrice&&info.raisePrice.toString().split('.')[1]?info.raisePrice.toString().split('.')[1]:'00'}}</span>
            <span @click="show = false" style="position:relative;">
                <span class="btndetail">价格明细</span>
                <img :src="show ? unfoldbottom : unfoldtop" class="imgt_detail" />
            </span>
            <van-button type="default" @click="save()" :loading="loading" loading-text="提交中" :loading-size="'1.6rem'">提交订单</van-button>
        </div>
    </van-popup>
    <van-popup
      v-model="areacode"
      round
      position="bottom"
      :style="{ height: '35%' }"
      class="areapopup"
    >
      <van-picker
        title="请选择区号"
        show-toolbar
        :columns="columns"
        ref="areapicker"
        :default-index="1"
        :visible-item-count="3"
      >
        <template v:slot="default">
          <span class="title">请选择区号</span>
          <img :src="close" class="close" @click="areacode = false" />
        </template>
        <template v:slot="columns-bottom">
          <van-button type="default" class="areasave" @click="onConfirm()"
            >确定</van-button
          >
        </template>
      </van-picker>
    </van-popup>
    <van-popup
      v-model="timepopup"
      round
      position="bottom"
      :style="{ height: '65%' }"
      class="timepopup"
    >
      <p>
        <span class="title">预计到店时间</span>
        <img :src="close" class="close" @click="timepopup = false" />
      </p>
      <div class="timeitems">
        <span
          :class="reachtime == item ? 'items active' : 'items'"
          v-for="(item, index) in timelist"
          :key="index"
          @click="changetime(item)"
          >{{ item }}</span
        >
      </div>
    </van-popup>
    <van-popup v-model="ordershow" class="orderinfo">
      <p class="orderinfo_item">正在生成订单</p>
      <p class="orderinfo_item">
        <span>{{ info.roomTypeName }}</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_item">
        <span>{{form.room_num}}间客房 x {{info.roomday}}晚</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_item" v-for="(item,index) in form.customer_person" :key="index">
        <span>房间入住人：{{item.Name}}</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_item">
        <span>订单总价：¥{{is_deduct_coin==true?parseInt(info.deductCoin)+parseInt(info.raisePrice):info.raisePrice}}</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_item" v-if="is_deduct_coin==true">
        <span>红包抵扣：-¥{{info.deductCoin}}</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_item">
        <span>在线支付：¥{{info.raisePrice}}</span>
        <img :src="succeed" />
      </p>
      <p class="orderinfo_footer">
        <img :src="succeed" v-if="!loading"/><span v-if="!loading">订单已经提交</span>
        <van-loading type="spinner" size="1.6rem" v-if="loading"/>
        <span v-if="loading">正在提交...</span>
      </p>
    </van-popup>
  </div>
</template>

<script>
import navBar from "../components/nav-bar";
import dsbridge from "dsbridge";
import { customFormatDate } from "../../../assets/hotel/js/common";
import { getOrderconfirmData,createOrderData,getPayment } from "../api";
import {mapState ,mapMutations} from 'vuex'
export default {
  components: {
    navBar,
  },
  data() {
    return {
        defaultPhoneHeight:'',
        nowPhoneHeight:'',
        isshowbottom:true,
      returnwhiteicon: require("@/assets/hotel/img/home/back_white.png"),
      succeed: require("@/assets/hotel/img/home/succeed.png"),
      helpicon: require("@/assets/hotel/img/home/help.png"),
      unfoldright: require("@/assets/hotel/img/home/unfold_right.png"),
      unfoldbottom: require("@/assets/hotel/img/home/unfold_bottom.png"),
      unfoldtop: require("@/assets/hotel/img/home/unfold_top.png"),
      unfoldtopl: require("@/assets/hotel/img/home/unfold_topl.png"),
      unfoldbottoml: require("@/assets/hotel/img/home/unfold_bottoml.png"),
      close: require("@/assets/hotel/img/home/close.png"),
      show: false,
      areacode: false, //区号的弹窗
      timepopup: false, //时间的弹窗
      ordershow: false, //订单的弹窗
      isroom: false, //房间数
      ispreference: false, //入住偏好
      columns: ["中国香港 +852","中国大陆 +86","中国澳门 +853","中国台湾 +886"],
      areavalue: "+86", //选中的区号
      timelist: ["不选择","6:00","7:00","8:00","9:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00",
        "19:00","20:00","21:00","22:00","23:00","24:00","次日 01:00","次日 02:00","次日 03:00","次日 04:00","次日 05:00","次日 06:00",],
      reachtime: "", //选中的到店时间
      asklist: [
        { name: "安静的房间", checked: false },
        { name: "高楼层", checked: false },
        { name: "无烟房", checked: false },
      ],
      info: {},
      inputValue: "",
      roomlist: ["1间","2间","3间","4间","5间","6间","7间","8间","9间","10间",],
      rooms: [],
      isdeduction:false,//微币大于100才显示抵扣红包
      form: {
        hotel_id: "", //酒店id
        room_id: "", //房型id
        start_time: "", //入住时间
        end_time: "", //结束时间
        people_num: "", //入住人数
        room_num: "", //房间数
        late_arrival_time: "", //最晚到店时间
        is_deduct_coin: "", //是否微币抵扣 1=抵扣,-1=不抵扣
        customer_person: [], //联系人
        mobile: "", //联系电话
        short_name: "", //平台英文缩写
        room_name: "", //房间名称
        bedName: "", //床型名详细
        remark: "", //其他要求
        order: { type: "hotelv2" ,client:10}, //订单类型
      },
      askremark:'',
      money:{},//存放用户微币和订单金额
      loading:true,
      is_deduct_coin:'',//是否抵扣红包
      arrivalTimeFrom:'',//最早入住时间
      arrivalTimeEnd:'',//最晚入住时间
      istime:0,//0到店时间在酒店的规定时间，1早于规定时间，1晚于规定时间
      rate:'',//比例
      roomprice:'',//房间单价
      loading:false,//提交订单按钮的加载
      ordersn:'',//订单号
      isremark:true,//是否可填写备注
      can_cancel_time:'',//可取消订单的时间
      priceDetail:[],
      scrollTop:0,//滚动高度
    };
  },
  watch: {
    // 监听相同路由下参数变化的时候，从而实现异步刷新----只有路由发生变化时
    $route(to, from) {
      if (from.path == "/hotel/confirmorder"&&to.path == "/hotel/confirmorder") {
        sessionStorage.setItem("confirmrouteReadyload", "true"); //路由调用初始化
        if (from.path == "/hotel/detail" && to.path == "/hotel/detail") {
          this.init();
        }
      } else {
        sessionStorage.setItem("confirmrouteReadyload", "false");
      }
    },
    nowPhoneHeight:function(){
        if(this.defaultPhoneHeight != this.nowPhoneHeight){
            //手机键盘被唤起了。
            this.isshowbottom=false;
        }else{
            //手机键盘被关闭了。
            this.isshowbottom=true;
        }
    }
  },
//   beforeRouteEnter(to, from, next) {
//     if (from.path == "/hotel/confirmorder") {
//       sessionStorage.setItem("hoteldatailrealyshow", "true");
//     }
//     next();
//   },
  //路由离开
  beforeRouteLeave(to, from, next) {
    if (to.path == "/hotel/detail") {
      sessionStorage.setItem("confirmrouteReadyload", "true");
    } else {
      sessionStorage.setItem("confirmrouteReadyload", "false");
    }
    next();
  },
  computed: {
    ...mapState({
      hotel: (state) => state.hotel,
    }),
  },
  created() {
    //   if(sessionStorage.getItem("confirmrouteReadyload")==true){
        this.init();
    //   }
    this.defaultPhoneHeight = window.innerHeight
    window.onresize = ()=>{
        this.nowPhoneHeight = window.innerHeight
    }
  },
  methods: {
      ...mapMutations(['setState']),
      init(){
            window.setPay=this.setPay;
            if (this.$route.query.token) {
            this.$api.setToken(this.$route.query.token);
            }
            let objh = this.hotel.hoteldetail.hotelinfo;
            let objr = this.hotel.hoteldetail.roominfo;
            let objs = this.hotel.ckeckinInfo;
         if(objh&&objr&&objs){
             if(objr.priceDetail[objr.priceDetail.length-1].dailyPrice!=''){
                objr.priceDetail.push({dailyPrice:'',time:this.getNextDate(objr.priceDetail[objr.priceDetail.length-1].time,1)});
             }
            this.can_cancel_time=objr.can_cancel_time;
            this.priceDetail=objr.priceDetail;
            this.arrivalTimeFrom=this.$route.query.arrivalTimeFrom;
            this.arrivalTimeEnd=this.$route.query.arrivalTimeEnd;
            this.rate=objr.roomTypeNames[0].rate;//计算积分的比例
            this.isremark=this.$route.query.is_remark;//是否可添加备注
            this.form.hotel_id = objh.hotel_id; //酒店id
            this.form.room_id =objr.roomTypeNames ? objr.roomTypeNames[0].room_id : ""; //房型id
            this.form.start_time = objs.start_time; //入住时间
            this.form.end_time = objs.end_time; //结束时间
            this.form.people_num = 1;//parseInt(objs.childNum) + parseInt(objs.adultNum); //入住人数
            this.form.room_num = 1;//objs.roomNum; //房间数
            this.form.short_name = objr.roomTypeNames? objr.roomTypeNames[0].short_name: ""; //平台英文缩写
            this.form.room_name = objr.roomTypeNames? objr.roomTypeNames[0].roomTypeName: ""; //房间名称
            this.form.bedName =  objr.roomTypeNames ? objr.roomTypeNames[0].bedName :""; //床型名详细objr.roomTypeNames ? objr.roomTypeNames[0].bedName :
            let arr = [];
            if(objh.policy && objh.policy.length>0){
                objh.policy.map((item) => {
                    if (item.Text != "") {
                        if (arr.length < 3) {
                        arr.push(item);
                        }
                    }
                });
            }
            this.money.nowCoin=objr.nowCoin;
            this.money.raisePrice=objr.totalPrice? objr.totalPrice:objr.roomTypeNames?objr.roomTypeNames[0].raisePrice:'';
            this.roomprice=objr.roomTypeNames[0].raisePrice//parseFloat(objr.totalPrice?objr.totalPrice:objr.roomTypeNames && objr.roomTypeNames[0].raisePrice)/parseInt(objs.roomNum);//一间房间的入住总价
            this.info = {
            chinese_name: objh.chinese_name, //酒店名称
            maxNum:objr.roomTypeNames && objr.roomTypeNames[0].maxNum, //最大房间定量
            roomTypeName: objr.roomTypeNames?objr.roomTypeNames[0].roomTypeName: "", //房型名称
            policy: arr, //订房必读
            nowCoin:objr.nowCoin.toFixed(2),//用户当前微币
            raisePrice:objr.totalPrice,//总价
            credits:objr.credits/objs.roomNum,//返还积分
            cancelPolicy:objr.roomTypeNames?objr.roomTypeNames[0].cancelPolicy:'',//不可取消
            labelBedName:objr.roomTypeNames?objr.roomTypeNames[0].labelBedName:'',//大床
            hasWindow:objr.roomTypeNames?objr.roomTypeNames[0].hasWindow:'',//有窗
            mealBreakFast:objr.breakFast,//objr.roomTypeNames?objr.roomTypeNames[0].mealBreakFast:'',//无早
            starttime:objs.start_timeWeek, //入住时间
            endtime:objs.end_timeWeek, //结束时间
            roomday:objs.roomday,//入住几晚
            priceDetail: objr.priceDetail,//入住时间与价格
            meals:objr.meals,//餐食
            };
            // this.changeroom(objs.roomNum + "间");
            this.changeroom("1间");
            this.deductionUA();
        }
      },
      showbottom(str){
          this.isshowbottom=str;
      },
      getNextDate(date, day) { 
      　　let dd = new Date(date);
      　　dd.setDate(dd.getDate() + day);
      　　let y = dd.getFullYear();
      　　let m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      　　let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      　　return y + "-" + m + "-" + d;
      },
      stopKeyborad () {
        this.$refs.scanTextbox.setAttribute('readonly', 'readonly');
        setTimeout(() => {
            this.$refs.scanTextbox.removeAttribute('readonly');
        }, 200);
        this.timepopup = true
      },
    deductionUA() {
        const ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(ua)) {
            this.form.order.client = 11;
        } else if (/android/.test(ua)) {
            this.form.order.client = 10;
        }
    },
    //返回上一页
    goback(status) {
      this.setState([{ name: 'hoteldetail',value: {'hotelinfo': this.hotel.hoteldetail.hotelinfo, 'roominfo': {}, canTakeTaxi: this.hotel.hoteldetail.canTakeTaxi } }])
      this.$router.go(-1);
    },
    customer(){
      this.params("6", "6", "customerService");
    },
    skip(){
        this.$router.push({
        path: "/hotel/detail",
        query: {
            hotel_id:this.form.hotel_id
        },
      });
    },
    getNowFormatDate(str) {
      //获取当前年月日
      var date = new Date(str);
      date.setDate(date.getDate() + 1);
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 抵扣微币计算方法：
    calculate() {
      let nowCoin = this.is_deduct_coin==true?this.info.nowCoin:this.money.nowCoin; //用户的微币
      let totalAmount = this.is_deduct_coin==true?this.info.raisePrice:this.money.raisePrice; //订单金额
      let deductCoin = 0;
      let actualAmount = 0;
      if (nowCoin) {
        nowCoin = Math.floor(nowCoin * 100) / 100; //微币只要两位小数
        let maxDeductCoin = Math.floor((totalAmount / 2) * 100) / 100; //最多只能抵扣订单金额的50%，保留两位小数，【只舍不入】
        if (nowCoin >= 100) {
          //用户的微币数必须大于100才可以使用
          if (nowCoin >= maxDeductCoin) {
            deductCoin = maxDeductCoin;
          } else {
            deductCoin = nowCoin;
          }
        }
        actualAmount = (totalAmount - deductCoin).toFixed(2); //应收金额
        nowCoin = nowCoin - deductCoin;
      } else {
        deductCoin = 0;
        actualAmount = totalAmount;
      }
        if(this.is_deduct_coin){
            this.info.nowCoin=nowCoin.toFixed(2)
            this.info.raisePrice=actualAmount
        }else{
            this.info.nowCoin=this.money.nowCoin.toFixed(2)
            this.info.raisePrice=this.money.raisePrice
        }
        this.info.deductCoin=deductCoin//.toFixed(2)
    },
    //计算房间总价
    calculateCredits(price,rate,systermRate=15){//price房间总价，rete后台配置的比例
        let trueRate = 0;
        if (rate > systermRate) {
            trueRate = 1;
        } else {
            trueRate = rate / systermRate;
        }
        if (trueRate < 0) {
            trueRate = 0;
        }
        return Math.round(price * trueRate);
    },
    changetime(item) {
      //最晚到店时间
      this.reachtime = item;
      if (item == "不选择") {
        this.form.late_arrival_time = "";
      } else {
        if (item.split(" ")[0] == "次日") {
            let date='';
            if(item.split(" ")[1].length>4){
                date=item.split(" ")[1]+':00';
            }else{
                date='0'+item.split(" ")[1]+':00';
            }
          this.form.late_arrival_time = this.getNowFormatDate(this.form.start_time) + " " + date;
        } else {
            if(item.split(':')[0]==24){
                this.form.late_arrival_time ==this.getNowFormatDate(this.form.start_time)+" 00:00:01"
            }else if(item.split(':')[0].length>1){
                this.form.late_arrival_time = this.form.start_time + " " + item+":00";
            }else{
                this.form.late_arrival_time = this.form.start_time + " 0" + item+":00";
            }
        }
        let time1=this.form.late_arrival_time.split(/[- : \/]/)
        let time=new Date(time1[0],time1[1],time1[2],time1[3],time1[4]);
        let mtime1=this.arrivalTimeFrom.split(/[- : \/]/)
        let mtime=new Date(mtime1[0],mtime1[1],mtime1[2],mtime1[3],mtime1[4],mtime1[5]);
        let ltime1=this.arrivalTimeEnd.split(/[- : \/]/)
        let ltime=new Date(ltime1[0],ltime1[1],ltime1[2],ltime1[3],ltime1[4],ltime1[5]);
        if(mtime.getTime()==ltime.getTime()){
            this.istime=-1;//最早和最晚入住时间相等时就代表没有入住时间限制
        }else{
            if(time.getTime()<mtime.getTime()){
                this.istime=1;
            }else if(time.getTime()>ltime.getTime()){
                this.istime=2;
            }else{
                this.istime=0;
            }
        }
      }
      this.timepopup = false;
    },
    changeroom(item) {
      //房间数
      this.form.room_num = item.split("间")[0];
      let arr = [];
      if (this.form.room_num > 1) {
        for (let i = 0; i < this.form.room_num; i++) {
          arr.push({ Name: "" });
        }
        arr[0].Name=this.inputValue
      }
      this.rooms = arr;
      this.info.raisePrice=parseFloat(this.roomprice)*parseInt(item.split("间")[0])//总价
      this.money.raisePrice=parseFloat(this.roomprice)*parseInt(item.split("间")[0])
      if(parseInt(this.money.nowCoin)>=100){
        this.calculate();
      }
      this.form.people_num= item.split("间")[0];
      this.isroom=false;
    },
    changeask(item) {
      //偏好
      this.asklist.map((res) => {
        if (res.name == item.name) {
          res.checked = !item.checked;
        }
      });
    },
    changededuct(event){
      this.is_deduct_coin = event
        this.calculate()
    },
    onConfirm() {
      let str = this.$refs.areapicker.getValues().toString();
      this.areavalue = str.split(" ")[1];
      this.areacode = false;
    },
    setPay(v){
        let data=JSON.parse(v);
        this.setState([{ name: 'hoteldetail',value: {'hotelinfo': this.hotel.hoteldetail.hotelinfo, roominfo: {}, canTakeTaxi: this.hotel.hoteldetail.canTakeTaxi } }])
        if(data.code==0){
            this.$router.push({//支付成功
                path: "/hotel/paysuccess",
                query: {
                    ordersn:this.ordersn
                },
            }) 
        }else{
            this.$router.push({//订单详情
                path: "/hotel/statusDetail",
                query: {
                    order_sn:this.ordersn
                },
            })  
        }
    },
    save() {
        if(this.form.late_arrival_time==''||this.form.late_arrival_time=='不选择'){
            this.form.late_arrival_time=this.form.start_time+' 14:00:00';
        }
        if(this.form.mobile==''){
            this.$toast('请填写联系电话');
            return false;
        }
        let flag=false;
        this.form.customer_person =this.inputValue != "" ? [{ Name: this.inputValue }] : this.rooms;
        this.form.customer_person.map((res)=>{
            if(res.Name==''){
                flag=true;
            }
        })
        if(flag){
            this.$toast('请填写住房姓名');
            return false;
        }
        this.form.remark=this.askremark;
        this.asklist.map((item) => {
            if (item.checked) {
            if (this.askremark != "") {
                this.form.remark += "," + item.name;
            } else {
                this.form.remark += item.name + ",";
            }
            }
        });
        this.form.area_code=this.areavalue;
        this.form.is_deduct_coin = this.is_deduct_coin == true ? 1 : -1;
        this.loading=true;
        getOrderconfirmData(this.form).then((res)=>{//确认订单
            this.ordershow = true;
            res.order.type="hotelv2";
            res.order.client=this.form.order.client;
            res.price_detail=this.priceDetail;
            createOrderData(res).then((ress)=>{//创建订单
                this.loading=false;
                let obj= {
                        "order_sn":ress.ordersn,                //类型：Number  必有字段  备注：订单id
                        "hotel_id":this.form.hotel_id,                //类型：Number  必有字段  备注：酒店id
                        "room_id":this.form.room_id,                //类型：Number  必有字段  备注：房型id
                        "start_time":this.form.start_time,                //类型：String  必有字段  备注：入住时间
                        "end_time":this.form.end_time,                //类型：String  必有字段  备注：离店时间
                        "people_num":this.form.people_num,                //类型：Number  必有字段  备注：入住人数
                        "room_num":this.form.room_num,                //类型：Number  必有字段  备注：预定房间数
                        "short_name":this.form.short_name,                //类型：String  必有字段  备注：平台英文名称
                        "late_arrival_time":this.form.late_arrival_time                //类型：String  必有字段  备注：最晚到店时间
                    }
                    getPayment(obj).then((item)=>{//支付验证
                        this.ordersn=ress.ordersn;
                        const param={actual_amount:ress.actual_amount,order_amount:ress.order_amount,ordersn:ress.ordersn,order_type:'hotelv2'}
                        if(this.form.order.client==11){
                            let that=this;
                            dsbridge.call("goPay",JSON.stringify(param),function(v){
                              that.setPay(v)
                            })
                        }else if(this.form.order.client==10){
                            this.params(JSON.stringify(param),JSON.stringify(param),'goPay')
                        }
                    }).catch(error=>{
                        this.loading=false;
                        let keys = Object.keys(error);
                        let key = keys[0];
                        let message = error.message || error[key][0]
                        if(error.code == 422){
                          this.$toast('入住时间不可早于今天')
                          setTimeout(()=>{
                            this.setState([{ name: 'hoteldetail',value: {'hotelinfo': {}, 'roominfo': {}, canTakeTaxi: this.hotel.hoteldetail.canTakeTaxi } }])
                            this.$router.go(-1)
                          },1000)
                        }
                        else if(message.slice(0, 10) == 'timeout of') {
                            this.$toast('网络不给力，请稍候重试');
                        }else {
                            this.$toast(message);
                            this.$router.push({//订单详情
                                path: "/statusDetail",
                                query: {
                                    order_sn:ress.ordersn
                                },
                            }) 
                        }
                    })
            }).catch(err => {
                this.loading=false
                this.ordershow = false;
                let keys = Object.keys(err);
                let key = keys[0];
                let message = err.message || err[key][0]
                if(message.slice(0, 10) == 'timeout of') {
                    this.$toast('网络不给力，请稍候重试');
                }else {
                    this.$toast(message);
                }
                
            });
        }).catch(err => {
            this.loading=false;
                this.ordershow = false;
                let keys = Object.keys(err);
                let key = keys[0];
                let message = err.message || err[key][0]
                if(message.slice(0, 10) == 'timeout of') {
                    this.$toast('网络不给力，请稍候重试');
                }else {
                    this.$toast(message);
                }
            });
    }
  },
  destroyed() {
        window.onresize = null
    }
}
</script>

<style lang="less">
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.nav .share-btn img {
    width: 1.6rem !important;
    height: 1.6rem !important;
}
.nav .nav-title span{
    font-weight: 500;
}
.confirmorder_main {
  background: #f5f6f7;
//   height: 100%;
  .title {
    font-size: 1.7rem;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight:bold;// 500;
    color: #333333;
  }
  .main_top {
    padding-top: 4.4rem;
    height: 5.5rem;
    font-size: 1.6rem;
    background: #108b30;
  }
  .confirmmain{
    position: sticky;
    top:0rem;
    width: 100%;
    z-index: 99;
    }
  .box_main {
    width: 100%;
    padding: 3.0rem 2.0rem 2.0rem 2.0rem;
    box-sizing: border-box;
    // transform: translateY(-1.5rem);
    border-top-left-radius: 2.0rem;
    border-top-right-radius: 2.0rem;
    background: #ffffff;
    .btndiv + .btndiv {
      margin-top: 1.0rem;
    }
    .headline {
      font-size: 1.8rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight:bold;// 500;
      color: #181818;
    }
    .box_item {
      display: flex;
      .box_date {
        flex: 2;
        text-align: left;
        font-size: 1.5rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #181818;
      }
      .box_facility {
        // flex: 1.5;
        flex: 1.2;
        text-align: center;
        font-size: 1.2rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        position: relative;
        top: 0.3rem;
      }
      .box_time {
        flex: 1;
        text-align: center;
        position: relative;
        top:0.1rem;
        span {
          display: inline-block;
          padding: 0.1rem 0.6rem;
          box-sizing: border-box;
          background: #108b30;
          color: #ffffff;
          font-size: 1.2rem;
          border-radius: 0.8rem;
        }
      }
    }
    .tag {
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 0.8rem;
      }
    }
    .tags {
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f84737;
    }
    .notice {
      margin-top: 3.0rem;
      ul {
        margin-top: 1.0rem;
        color: #108b30;
        font-size: 1.4rem;
        li {
          line-height: 2.5rem;
        //   font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          label {
            margin-right: 0.8rem;
            display: inline-block;
            width: 0.6rem;
            height: 0.6rem;
            background: #108b30;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .item_main {
    margin-bottom: 1.0rem;
    padding: 2.0rem 2.0rem;
    box-sizing: border-box;
    background: #ffffff;
    font-size: 1.4rem;
    .items {
      margin-top: 2.0rem;
      .tiptext {
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .text {
        display: inline-block;
        width: 9.0rem;
      }
      .tag {
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #333333;
        margin-right: 2.0rem;
        position: relative;
      }
      .imgo {
        width: 1.0rem;
        float: right;
        position: relative;
        top: 0.4rem;
      }
      .imgt {
        width: 1.0rem;
        position: relative;
        // top: 0.3rem;
      }
      .imgt_tel{
        width: 1.0rem;
        position: absolute;
        top: 0.3rem;
      }
      input {
        border: none;
        font-weight: 500;
      }
      input::-webkit-input-placeholder{
        color: #cccccc;
        font-weight: normal;
      }
    }
    .tips {
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight:400;
      color: #666666;
    }
    .label {
      margin-top: 1.0rem;
      font-size: 1.3rem;
      color: #999999;
    }
    .onsale {
      margin: 1.0rem 0 3.0rem 0;
      font-size: 1.6rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f9591b;
    }
    .remark {
      margin-top: 1.0rem;
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 2.2rem;
    }
    .room {
      .mark {
        margin-top: 1.0rem;
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f84737;
      }
      .room_list {
        margin: 2.0rem 0;
      }
      .room_item {
        display: inline-block;
        // padding: 0.9rem 2.0rem;
        text-align: center;
        border-radius: 1.8rem;
        background: #eeeeee;
        font-size: 1.3rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight:400;
        color: #333333;
      }
      .room_none {
        color: #cccccc;
        background: #f5f5f5;
      }
      .room_active {
        color: #ffffff;
        background: #108b30;
      }
      .room_item:nth-child(1),
      .room_item:nth-child(2),
      .room_item:nth-child(3),
      .room_item:nth-child(4),
      .room_item:nth-child(6),
      .room_item:nth-child(7),
      .room_item:nth-child(8),
      .room_item:nth-child(9) {
        margin-right: 0.4rem;
      }
      .room_item:nth-child(1),
      .room_item:nth-child(2),
      .room_item:nth-child(3),
      .room_item:nth-child(4),
      .room_item:nth-child(5) {
        margin-bottom: 1.0rem;
      }
      .roomo{
            display: flex;
            flex-wrap: wrap;
            .room_item{
            display: inline-block;
            width: 19%;
            height: 3.5rem;
            line-height: 3.5rem;
            };
        }
    }
    .askfor {
      .asktitle {
        font-size: 1.5rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #333333;
        margin: 1.5rem 0 1.0rem 0;
        .askspan {
          float: right;
          font-size: 1.4rem;
          color: #999999;
          font-weight: 400;
          text-align: right;
        }
        .imgt {
          width: 1.0rem;
          float: right;
          position: relative;
          top: 0.6rem;
          left:0.2rem;
        }
      }
      .asktip {
        background: #ecf6ef;
        border-radius: 1.0rem;
        border: 0.1rem solid #108b30;
        padding: 1.0rem;
        box-sizing: border-box;
        font-size: 1.3rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #108b30;
      }
      .asklabel {
        display: inline-block;
        padding: 0.9rem 2.0rem;
        border-radius: 1.8rem;
        background: #eeeeee;
        font-size: 1.3rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-right: 0.7rem;
      }
      .active {
        color: #108b30;
        background: #ecf6ef;
        border: 0.1rem solid #108b30;
        position: relative;
      }
      .active::after {
        content: "✓";
        position: absolute;
        bottom: 0rem;
        font-size: 1.6rem;
      }
      textarea {
        width: 100%;
        height: 15.0rem;
        margin-top: 2.0rem;
        padding: 1.5rem 2.0rem;
        box-sizing: border-box;
        border: none;
        background: #f4f4f4;
        border-radius: 1.0rem;
      }
      .van-cell {
        padding: 0rem;
      }
    }
  }
  .orderbox {
    position: sticky;
    bottom: 0rem;
    width: 100%;
    padding: 2.0rem 2.0rem 4.0rem 2.0rem;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0rem -0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
    .deduction {
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .tip {
        float: right;
        font-size: 1.5rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #f9591b;
      }
      .coloccc{
        color: #ccc !important;
      }
      .van-checkbox {
        display: inline-block;
        float: right;
        position: relative;
        top: 0.3rem;
        margin-left: 1.0rem;
        .van-checkbox__icon {
          font-size: 1.5rem;
        }
        .van-checkbox__icon--checked .van-icon {
          background: linear-gradient(135deg, #ff7742 0%, #ff5a4b 100%);
          border-color: #ff7742;
        }
      }
    }
    .remark {
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight:400;
      color: #999999;
    }
    .order_box {
    //   margin-top: 1.8rem;
      .tag {
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight:400;
        color: #333333;
      }
      .price {
        font-size: 1.2rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f84737;
        margin: 0 0.5rem 0 0.5rem;
        .sum {
          font-size: 2.0rem;
        }
      }
      .btndetail {
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight:400;
        color: #999999;
      }
      .imgt {
        width: 0.8rem;
        height: 0.8rem;
        position:relative;
        // top:1.3rem;
        left:0.2rem;
      }
      .imgt_info{
         width: 0.8rem;
        height: 0.8rem;
        position:absolute;
        top:0.3rem;
        right:-1rem; 
      }
      .van-button--normal {
        float: right;
        position: relative;
        top:-0.4rem;
        width: 10.0rem;
        height: 4.0rem;
        background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
        border-radius: 2.3rem;
        font-size: 1.5rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #ffffff;
        border: none;
      }
    }
  }
  .orderpopup {
    padding: 2.0rem 2.0rem 3.0rem 2.0rem;
    box-sizing: border-box;
    .order_box {
      margin-top: 1.8rem;
      .tag {
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .price {
        font-size: 1.2rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f84737;
        margin: 0 0.5rem 0 0.5rem;
        .sum {
          font-size: 2.4rem;
        }
      }
      .btndetail {
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .imgt {
        width: 0.8rem;
        height: 0.8rem;
        position: relative;
        // top:1.5rem;
        left:0.2rem;
      }
      .imgt_detail{
          width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        top:0.1rem;
        right:-1rem;
      }
      .van-button--normal {
        float: right;
        position: relative;
        top:-0.4rem;
        width: 10.6rem;
        height: 4.0rem;
        background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
        border-radius: 2.3rem;
        font-size: 1.6rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight:bold;// 500;
        color: #ffffff;
      }
    }
    // .detail_box p:nth-child(3) {
    //   margin-bottom: 1.0rem;
    // }
    .title {
        font-size: 2.0rem;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;//500;
        color: #333333;
      }
      .close {
        width: 2.2rem;
        height: 2.2rem;
        float: right;
      }
    .detail_box {
      .detail_item {
        border-bottom: 0.1rem solid #eeeeee;
        padding: 1.0rem 0;
        box-sizing: border-box;
        margin: 1.0rem 0;
        .item_title {
          font-size: 1.6rem;
        //   font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        .item_tip {
          float: right;
          font-size: 1.4rem;
        //   font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
      .items {
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight:400;
        color: #999999;
      }
      .price {
        float: right;
        font-size: 1.4rem;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight:400;
        color: #f84737;
      }
      .price_info{
        float: right;
      }
      .info_content{
        line-height: 3rem;
      }
      .lastinfo{
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 1.5rem;
        padding-bottom: 0.5rem;
      }
    }
  }
  .areapopup {
    padding: 2.0rem 2.0rem;
    box-sizing: border-box;
    .title {
      font-size: 2.0rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;//500;
      color: #333333;
    }
    .close {
      width: 2.2rem;
      height: 2.2rem;
      float: right;
    }
    .areasave {
      position: absolute;
      bottom: -6.0rem;
      z-index: 999;
      background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
      border-radius: 2.3rem;
      width: 100%;
      height: 4.5rem;
      font-size: 1.8rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight:bold;// 500;
      color: #ffffff;
    }
    .van-picker-column__item--selected {
      background: #eef7f0;
    }
    // .van-picker__columns{
    //     height: 17.0rem!important;
    // border:0.1rem solid black;
    //     .van-picker__mask{
    //         background-size: 100% 5.5rem!important;
    //     }
    // }
  }
  .timepopup {
    padding: 2.0rem 2.0rem;
    box-sizing: border-box;
    .title {
      font-size: 2.0rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight:bold;// 500;
      color: #333333;
    }
    .close {
      width: 2.2rem;
      height: 2.2rem;
      float: right;
    }
    .timeitems {
      margin-top: 2.0rem;
      display: flex;
      flex-wrap: wrap;
      height: 88%;
      overflow: auto;
    }
    .timeitems .active {
      color: #ffffff;
      background: #108b30;
    }
    .items {
      display: inline-block;
    //   width: 10.0rem;
      width: 32%;
      height: 3.6rem;
      text-align: center;
      line-height: 3.6rem;
      background: #eeeeee;
      font-size: 1.4rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight:400;
      color: #333333;
      border-radius: 1.8rem;
      margin-bottom: 1.0rem;
    }
    .items:nth-child(1),
    .items:nth-child(2),
    .items:nth-child(4),
    .items:nth-child(5),
    .items:nth-child(7),
    .items:nth-child(8),
    .items:nth-child(10),
    .items:nth-child(11),
    .items:nth-child(13),
    .items:nth-child(14),
    .items:nth-child(16),
    .items:nth-child(17),
    .items:nth-child(19),
    .items:nth-child(20),
    .items:nth-child(22),
    .items:nth-child(23),
    .items:nth-child(25) {
      margin-right: 0.5rem;
    }
  }
  .orderinfo {
    width: 31.5rem;
    background: #ffffff;
    border-radius: 2.0rem;
    padding: 2.0rem;
    box-sizing: border-box;
    .orderinfo_item:nth-child(1) {
      font-size: 1.8rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight:bold;// 500;
      color: #181818;
      text-align: center;
    }
    .orderinfo_item {
      margin-bottom: 2.0rem;
      font-size: 1.6rem;
    //   font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #181818;
      img {
        float: right;
        width: 1.6rem;
        height: 1.6rem;
        position: relative;
        top: 0.3rem;
      }
    }
    .orderinfo_footer {
      margin-top: 3.0rem;
      text-align: center;
      font-size: 1.6rem;
    //   font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;//500;
      color: #181818;
      img {
        width: 1.6rem;
        height: 1.6rem;
        position: relative;
        top: 0.3rem;
        margin-right: 0.3rem;
      }
      .van-loading {
        display: inline-block;
        margin-right: 0.3rem;
      }
    }
  }
}
</style>